import { cn } from "@/lib/utils";

interface AmyBadgeProps {
  className?: string;
  imgClassName?: string;
}

export default function AmyBadge({ className = "", imgClassName = "" }: AmyBadgeProps) {
  return (
    <div className={cn("flex flex-row items-center gap-1 p-1 pr-2 rounded-pill bg-sidebar border shrink-0", className)}>
      <img
        src="/amy.svg"
        className={cn("size-12 rounded-pill object-cover border shrink-0 bg-background", imgClassName)}
        alt="Amy"
      />
      Amy
    </div>
  )
}
